<template lang="pug">
label.toggle-switch-wrapper.primary-toggle(:class="textPositionClass")
  input(
    type="checkbox"
    :checked="value"
    :disabled="disabled"
    @change="toggle($event)"
  )
  .toggle-switch
  .inline-control-label(v-if="label")
    | {{ label }}
  .inline-control-label(v-else)
    slot
</template>

<script>
export default {
  name: 'AppSwitch',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    textPosition: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    textPositionClass() {
      return `toggle-switch-text-${this.textPosition}`;
    },
  },
  methods: {
    toggle(e) {
      this.$emit('change', e.target.checked);
    },
  },
};
</script>
